import Portals from '../views/layouts/Portals.jsx';
import SystemPortals from '../views/layouts/SystemPortals.jsx';
import View from '../views/layouts/PortalView/index.js';
import SystemPortalView from '../views/layouts/SystemPortalView/index.js';
import Edit from '../views/layouts/PortalForm/containers/Edit.js';
import Create from '../views/layouts/PortalForm/containers/Create.js';
import CreateSystemPortal from '../views/layouts/SystemPortalForm/containers/Create.js';
import EditSystemPortal from '../views/layouts/SystemPortalForm/containers/Edit.js';

import NotFound from '../views/common/StatusCodes.jsx';

import requireAuth from '~/views/enhancers/requireAuth.jsx';
import SubRoutes from './components/SubRoutes.jsx';


const ROOT_PATH = '/col/portals';
const PORTAL_SYSTEM_ROOT_PATH = '/col/portalSystem';

export default [
    {
        path: ROOT_PATH,
        exact: true,
        component: requireAuth(Portals),
    },
    {
        path: `${ROOT_PATH}/create`,
        exact: true,
        component: requireAuth(Create),
    },
    {
        path: `${ROOT_PATH}/:id`,
        component: requireAuth(SubRoutes),
        routes: [
            {
                path: `${ROOT_PATH}/:id`,
                exact: true,
                component: View,
            },
            {
                path: `${ROOT_PATH}/:id/edit`,
                exact: true,
                component: Edit,
            },
            {
                path: '*', component: NotFound,
            },
        ],
    },
    {
        path: PORTAL_SYSTEM_ROOT_PATH,
        exact: true,
        component: requireAuth(SystemPortals),
    },
    {
        path: `${PORTAL_SYSTEM_ROOT_PATH}/create`,
        exact: true,
        component: requireAuth(CreateSystemPortal),
    },
    {
        path: `${PORTAL_SYSTEM_ROOT_PATH}/:id`,
        component: requireAuth(SubRoutes),
        routes: [
            {
                path: `${PORTAL_SYSTEM_ROOT_PATH}/:id`,
                exact: true,
                component: SystemPortalView,
            },
            {
                path: `${PORTAL_SYSTEM_ROOT_PATH}/:id/edit`,
                exact: true,
                component: EditSystemPortal,
            },
            {
                path: '*', component: NotFound,
            },
        ],
    },
];
